import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFlutterComponent } from './simple-icons-flutter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFlutterComponent ],
    exports:      [ SimpleIconsFlutterComponent ],
    bootstrap:    []
})
export class SimpleIconsFlutterModule {}
